import { PLATFORMS } from '../../../constants/platforms.js';
import { getCategories } from './categories.js';
import { checkout } from './checkout.js';
import { getProducts } from './products.js';
import { getUser } from './user.js';
import { getProductPrice } from '../../../store/product_price.js';

class WebPlatform {
    products(customStorefrontName) {
        return getProducts(customStorefrontName);
    }
    categories(customStorefrontName) {
        return getCategories(customStorefrontName);
    }
    checkout(externalProductId, quantity, customStorefrontName, customFields) {
        return checkout(externalProductId, quantity, customStorefrontName, customFields);
    }
    user(force = false) {
        return getUser(force);
    }
    isAccountCompleted() {
        return Promise.resolve(false);
    }
    getProductVariablePrice(productCode, quantity, customStorefrontName) {
        return getProductPrice(productCode, quantity, PLATFORMS.WEB, customStorefrontName);
    }
}

export { WebPlatform };
//# sourceMappingURL=index.js.map
